// User site (frontend/public) ke casino images — admin me same files chahiye
// (cards, cricket20 balls, fight icon, score bg). Vite build inhe admin bundle me copy karta hai.
const FILES = import.meta.glob(
  [
    "../../../frontend/public/assets/img/cards/*.{png,jpg}",
    "../../../frontend/public/assets/img/balls/cricket20/*.png",
    "../../../frontend/public/assets/img/fight.png",
    "../../../frontend/public/img/score-bg.png",
  ],
  { eager: true, query: "?url", import: "default" }
);

// userSiteAsset("assets/img/cards/K.png") → bundled url (ya "" agar file nahi)
export const userSiteAsset = (rel) => FILES[`../../../frontend/public/${rel}`] || "";
